import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/sad-cry': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM392 394.4V280C392 266.8 381.2 256 368 256S344 266.8 344 280V431.4C315.5 447 282.8 456 248 456S180.5 447 152 431.4V280C152 266.8 141.2 256 128 256S104 266.8 104 280V394.4C69.4 358.4 48 309.7 48 256 48 145.7 137.7 56 248 56S448 145.7 448 256C448 309.7 426.6 358.5 392 394.4zM205.8 234.5C210.2 232.1 212.7 227.1 211.9 222.1 207.9 196.9 177.7 180 152.1 180S96.2 196.9 92.3 222.1C91.5 227.1 94 232.1 98.4 234.5 102.8 236.9 108.3 236.3 112.1 232.9L121.6 224.4C136.4 211.2 167.8 211.2 182.6 224.4L192.1 232.9C194.6 235.2 200 237.7 205.8 234.5zM344 180C318.3 180 288.1 196.9 284.2 222.1 283.4 227.1 285.9 232.1 290.3 234.5 294.8 236.9 300.2 236.3 304 232.9L313.5 224.4C328.3 211.2 359.7 211.2 374.5 224.4L384 232.9C386.5 235.1 392 237.6 397.7 234.5 402.1 232.1 404.6 227.1 403.8 222.1 399.9 196.9 369.7 180 344 180zM248 272C217.1 272 192 300.7 192 336S217.1 400 248 400 304 371.3 304 336 278.9 272 248 272z'
      }
    ]
  }
})
